import InfoOutlined from "@mui/icons-material/InfoOutlined";

import useBanners from "@app/analytics/hooks/useBanners";
import useWorkspaceInvite from "@app/analytics/hooks/workspace/useWorkspaceInvite";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import ROUTES from "@app/common/routes";

import Alert from "@rui/Alert";
import Button from "@rui/Button";
import { Link } from "@rui/Link";

const INVITE_ROUTES = [ROUTES.MEETING_REPORTS, ROUTES.CALENDAR];

const InvitePendingAlert = ({ priority }: { priority: number }) => {
  const [inviteDismissed, setInviteDismissed] = useLocalStorage(
    "inviteDismissed",
    false
  );
  const { invite } = useWorkspaceInvite();
  const isPending = invite?.status === "pending";

  const shouldShow =
    isPending && !inviteDismissed && INVITE_ROUTES.includes(location.pathname);

  const { show } = useBanners({
    id: "workspaceInvite",
    priority,
    shouldShow,
  });

  const handleDismissed = () => {
    setInviteDismissed(true);
  };

  if (!show || !invite) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<InfoOutlined sx={{ color: "shades.primary.600" }} />}
      action={
        <Link to={ROUTES.INVITATION_WORKSPACE}>
          <Button sx={{ height: "40px" }}>Review Invitation</Button>
        </Link>
      }
      onDismiss={handleDismissed}
      dismissible
      sx={{ color: "shades.primary.600" }}
    >
      You have been invited to join the {invite.workspaceName} Workspace.
    </Alert>
  );
};

export default InvitePendingAlert;
